import { endpoint } from "views/pages/manage/common/constant"
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { paymentModeMapping } from "./constant"
import { fetchAllPDF } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { downloadFileByS3Key } from "views/pages/manage/edpOps/studentDetails/paymentSummary/viewInvoice/ViewInvoicesDialog"
const { fetchAllPostPromisedData } = require("views/pages/manage/common/utils/methods/commonMethods/utilityMethod")

export const getReceiptDetail=async(data)=>{


    const request={
      "receiptId":data?. receiptId,
      "acknowledgementId": data?.acknowledgementId,
      "psid": data?.psid,
      "applicationId":data?. applicationId,
      "businessArea":data?.businessArea,
      businessAreaId:data?.buId
  }
    const url=endpoint.manageReceipts.view;
    try{
   const response= await fetchAllPostPromisedData(url,request,"post")
    if(response.code==200){
     return response?.data
    }
    }
    catch(error){
        console.log(error)
    }

}

export const getLogDetails= async(params,locationState,amountPaid)=>{
  const {psid}=params
      const request={
        "acknowledgementId":amountPaid<0?null:locationState?. acknowledgementId,
        "psid": psid,
        "applicationId": locationState?.applicationId,
        pserpReceiptId: locationState?.receiptId
    }
  const url=endpoint.paymentCollection.getAudit;
  try{
  const response= await fetchAllPostPromisedData(url,request,"post")
  if(response.code==200){
   return response.data.map((item,index)=>({...item,id:index}))
  }
  }
  catch(error){
    console.log(error);
  }
}

export const getRoleId=async(data)=>{
  const details = await fetchAllPromisedData(
    `${endpoint.getUserByEmployeeId}/${data?.employeeId}`,
    true
  );
  if (details && details?.code == 200) {
    const roleId = await details?.data?.userIdProjectRoleDtoList
      .map((item) => {
        return item?.roleInformationDtoList.map((i) => {
          return i?.roleId;
        });
      })
      .flat();
    return roleId;
  }

}
export const getApproval= async(studentBasicDetails,paymentModeDetails,bankMasterId,oldPaymentMode,setApprovalOpen,setIsOpen,setModifyPaymentModeData,paymentModeCollectionDetailsId)=>{
  const {psid,applicationId,buId,receiptId,receiptDate,acknowledgementId='', oldReferenceNumber}=studentBasicDetails
  const {paymentModeDate,referenceNumber,cardType,firstName,lastName,gatewayName,onlineSale,paidAmount,paymentModeAttachmentS3Key}=paymentModeDetails
const request={
    "psid":psid,
    applicationId,
    acknowledgementId,
    "businessAreaId":buId,
    businessAreaDisplayValue:studentBasicDetails?.businessArea,
    "pserpReceiptId":receiptId,
    courseId:studentBasicDetails?.courseId,
    term:studentBasicDetails?.term,
    receiptDate,
    "newPaymentMode":paymentModeMapping[paymentModeDetails?.paymentMode]=='Cash'?'CASH':(paymentModeMapping[paymentModeDetails?.paymentMode]??paymentModeDetails?.paymentMode),
    oldPaymentMode,
    paymentModeDate,
    referenceNumber:referenceNumber?.value??referenceNumber,
    "paymentModeId":bankMasterId[paymentModeMapping[paymentModeDetails?.paymentMode]]??bankMasterId[paymentModeDetails?.paymentMode],
    "voucherId":"",
    bankMasterId:paymentModeDetails?.bank?.id,
    bankName: (paymentModeMapping[paymentModeDetails?.paymentMode]??paymentModeDetails?.paymentMode)== "EFT"
    ? paymentModeDetails?.bank?.label
    : paymentModeDetails?.bank?.value,
    paymentModeAttachmentS3Key,
    cardType:cardType?.label,
    firstName,
    lastName,
    gatewayName ,
    onlineSale:onlineSale?.label,
    paidAmount,
    oldReferenceNumber,
    paymentModeCollectionDetailsId
  }
  
  const url = endpoint?.paymodeApproval?.submitPaymodeUpdateRequest;;
  try {
    const response = await fetchAllPostPromisedData(url, request, "post");
    if (response.code == 200) {
      setApprovalOpen(true);
      setIsOpen(false)
      setModifyPaymentModeData({})
      return response?.data  
    }
  }
  catch (error) {
    console.log(error)
  }

}

export const checkPaymentModeApprovalStatus=async(receiptId,setModifyOpen)=>{
  try{
  const res=await fetchAllPostPromisedData(`${endpoint?.paymodeApproval?.checkPaymentModeApprovalStatus}?receiptId=${receiptId}`,{})
  if(res?.code==200){
    setModifyOpen(true)
  }
}
catch(error){
  console.log(error)
}
}

export const getPaymentInfo=async(studentBasicDetails,rowData)=>{
const req={
  "receiptId": studentBasicDetails?.receiptId,
  "psid": studentBasicDetails?.psid,
  "businessArea": studentBasicDetails?.businessArea,
  "paymentMode": rowData?.paymentMode,
  "referenceNumber" : rowData?.referenceNumber,
  "amount" : rowData?.paidAmount,
  "businessAreaId": studentBasicDetails?.buId
}
const url=endpoint?.manageReceipts?.paymentInfo;
try{
  const res=await fetchAllPostPromisedData(url,req)
  if(res?.code==200){
    return res?.data[0]
  }
  else{
    return false
  }
}
catch(error){
  console.log(error)
}
}

export const downloadAttachment= async (fileName,attachmentType='CHEQUE_DD',isRemovePserp)=>{
isRemovePserp?await downloadFileByS3Key(fileName): await fetchAllPDF(`${endpoint?.manageReceipts?.downloadAttachment}?fileName=${fileName}&attachmentType=${attachmentType}`,false, true,
  '',
  '',fileName)
//  try{
//  const pdfBlob = await res.blob();

//         // Create a download link
//         const downloadLink = document.createElement('a');
//         console.log('downloadLink',downloadLink)
//         const url = URL.createObjectURL(pdfBlob);
//         downloadLink.href = url;
//         downloadLink.download = 'file.pdf'; // Desired file name

//         // Trigger download
//         document.body.appendChild(downloadLink);
//         downloadLink.click();

//         // Clean up
//         document.body.removeChild(downloadLink);
//         URL.revokeObjectURL(url);
//     } catch (error) {
//         console.error('Error downloading PDF:', error);
//     }
}